<ngb-carousel style="margin-top: 3x;" *ngIf="images">
    <ng-template *ngFor="image of images; let i = index" style="justify-content: center; display: flex;" ngbSlide>
      <div class="picsum-img-wrapper">
        <img (click)="navigate(i)" style="cursor: pointer;;width: 100%; max-height: 50vh;" [src]="images[i]" alt="Random first slide">
      </div>
    </ng-template>
  </ngb-carousel>
  